import React from 'react'
import { useTranslation } from 'react-i18next'

import App from 'components/App'

import styles from './DialogPopupText.module.scss'

export type Props = {
  open: boolean
  text: string
  onClose: () => void
}

const DialogPopupText: React.FC<Props> = ({ open, text, onClose }) => {
  const { t } = useTranslation()

  const renderTextWithLineBreaks = (content: string) => {
    return content.split('\n').map((line, index, array) => (
      <React.Fragment key={index}>
        {line}
        {index < array.length - 1 && <br />}
      </React.Fragment>
    ))
  }

  return (
    <App.Dialog open={open} centered onClose={onClose}>
      <App.Flex column gap={6} className={styles.container}>
        <App.Flex column gap={3}>
          <App.Text center medium>{renderTextWithLineBreaks(text)}</App.Text>
        </App.Flex>

        <App.Button onClick={onClose}>{t('Close')}</App.Button>
      </App.Flex>
    </App.Dialog>
  )
}

export default DialogPopupText
